import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {useHistory} from 'react-router-dom'
import { useAlert } from 'react-alert';
import { Alert, Container, Row, Modal, Offcanvas, Button, FormSelect, ProgressBar } from 'react-bootstrap';
import api from '../../seller-apis/api';
import servicesApi from '../../seller-apis/servicesApi';
import './register.css';
// Images related
var imagesName = [];
var s3Urls = [];


function Register3() {

    const alert = useAlert();
    let history = useHistory();

    // Input fields

    const [gstNo, setGstNo] = useState("");
    const [mobile, setmobile] = useState("");
    const [email, setemail] = useState("");
    const [state, setstate] = useState("first");
    const [mobileState, setmobileState] = useState("mobile");
    const [emailState, setemailState] = useState("email")
    const [progress, setprogress] = useState(0);
    const [otpSent, setotpSent] = useState(false);

    const [rName, setrName] = useState("");
    const [remail, setremail] = useState("");
    const [raddress, setraddress] = useState("");
    const [rpickupaddress, setrpickupaddress] = useState("");
    const [rphone, setrphone] = useState();
    const [rcity, setrcity] = useState();
    const [rzip, setrzip] = useState();
    const [rgst, setrgst] = useState();
    const [rtype, setrtype] = useState();
    const [rState, setrState] = useState();
    const [amzurl, setamzurl] = useState();

    // Otp input mobile
    const [first, setfirst] = useState();
    const [second, setsecond] = useState();
    const [third, setthird] = useState();
    const [fourth, setfourth] = useState();

    // otp input email
    const [firstmail, setfirstmail] = useState();
    const [secondmail, setsecondmail] = useState();
    const [thirdmail, setthirdmail] = useState();
    const [fourthmail, setfourthmail] = useState();

    // Images Related 
    const [urlList, seturlList] = useState([]);
    const [urlListshow, seturlListshow] = useState(false);
    const [imgprogress, setimgprogress] = useState()


    function progressfun(now) {
        for (let i = now; i <= now + (100 / 2); i++) {
            setprogress(i);
        }
        setstate("second")
    }

    // Show Image

    function showImage(event) {
        seturlListshow(false)

        let comImg;
        let imageFinal;
        let registerImage;
        let limit = event.target.files.length;
        console.log(event.target.files.length)
        if (event.target.files.length > 2) {
            limit = 2 - urlList.length;
        }

        for (let i = 0; i < limit; i++) {
            console.log(i)
            var str = event.target.files[i].name;
            let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
            comImg = str.replace(/[^\w]/g, "");
            imageFinal = comImg + extension
            registerImage = event.target.files[0];
            imagesName.push(imageFinal)
            var data = {
                "imageName": imageFinal,
                "type": "products"
            }
            servicesApi.saveImage(data).then((res) => {
                axios({
                    method: 'put',
                    url: res.data,
                    data: registerImage,
                    onUploadProgress: data => {
                        //Set the progress value to show the progress bar
                        setimgprogress(Math.round((100 * data.loaded) / data.total))
                    },
                })
                    .then(response => {
                        setimgprogress()
                        seturlList(imagesName)
                        seturlListshow(true)
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }).catch((err) => console.log(err))
            s3Urls.push(imageFinal)

        }


    }

    // Delete image

    function deleteImg(index) {
        seturlListshow(false)
        seturlList([]);

        imagesName.splice(index, 1);
        let eleLoader = document.getElementById("loader-Img-upload");

        seturlList(imagesName)

        eleLoader.setAttribute('class', 'spinner-border text-info');

        setTimeout(() => {

            eleLoader.removeAttribute('class');

            seturlListshow(true)
        }, 1000);
    }


    // Input otp

    function inputotp(e, no) {
        console.log(e)
        let btns = document.getElementsByClassName("form-control-val");

        if (e.keyCode === 8) {
            if (no > 0) {
                console.log("dnjk")
                btns[no].value = ""
                btns[no].disabled = false;
                btns[no - 1].disabled = false
                btns[no - 1].focus();

            }
            else {
                btns[no].disabled = false;
                btns[no].value = ""
                btns[no].focus()
            }
        }
        else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
            console.log(typeof (btns[no].value))
            if (no < 3) {
                btns[no + 1].disabled = false;
                btns[no].disabled = true
                btns[no + 1].focus()
            }
            else {
                //  btns[no].disabled = true;
                btns[no].focus()
                btns[no].select()
            }
        }
    }


    // Input otp mail

    function inputotmail(e, no) {
        let btns = document.getElementsByClassName("form-control-mail");

        if (e.keyCode === 8) {
            if (no > 0) {
                console.log("dnjk")
                btns[no].value = ""
                btns[no].disabled = false;
                btns[no - 1].disabled = false
                btns[no - 1].focus();

            }
            else {
                btns[no].disabled = false;
                btns[no].value = ""
                btns[no].focus()
            }
        }
        else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
            console.log(typeof (btns[no].value))
            if (no < 3) {
                btns[no + 1].disabled = false;
                btns[no].disabled = true
                btns[no + 1].focus()
            }
            else {
                //  btns[no].disabled = true;
                btns[no].focus()
                btns[no].select()
            }
        }
    }

    function handleInput(e, num) {
        if (isNaN(e)) {
            if (num === 0) {
                setfirst(first)
            }
            else if (num === 1) {
                setsecond(second)
            }
            else if (num === 2) {
                setthird(third)
            }
            else if (num === 3) {
                setfourth(fourth)
            }
        }
        else {
            if (e > 9) {
                if (num === 0) {
                    setfirst(first)
                }
                else if (num === 1) {
                    setsecond(second)
                }
                else if (num === 2) {
                    setthird(third)
                }
                else if (num === 3) {
                    setfourth(fourth)
                }
            }
            else {
                if (num === 0) {
                    setfirst(e)
                }
                else if (num === 1) {
                    setsecond(e)
                }
                else if (num === 2) {
                    setthird(e)
                }
                else if (num === 3) {
                    setfourth(e)
                }
            }
        }

    }

    // Handle input mail

    function handleInputMail(e, num) {
        if (isNaN(e)) {
            if (num === 0) {
                setfirstmail(firstmail)
            }
            else if (num === 1) {
                setsecondmail(secondmail)
            }
            else if (num === 2) {
                setthirdmail(thirdmail)
            }
            else if (num === 3) {
                setfourthmail(fourthmail)
            }
        }
        else {
            if (e > 9) {
                if (num === 0) {
                    setfirstmail(firstmail)
                }
                else if (num === 1) {
                    setsecondmail(secondmail)
                }
                else if (num === 2) {
                    setthirdmail(thirdmail)
                }
                else if (num === 3) {
                    setfourthmail(fourthmail)
                }
            }
            else {
                if (num === 0) {
                    setfirstmail(e)
                }
                else if (num === 1) {
                    setsecondmail(e)
                }
                else if (num === 2) {
                    setthirdmail(e)
                }
                else if (num === 3) {
                    setfourthmail(e)
                }
            }
        }
    }


    //   Send otp mobile func

    function sendOtp(payload) {
        if (payload === "mobile") {
            if (mobile === "" || mobile === undefined || mobile.length != 10) {
                alert.info("Please enter a valid mobile number")
            }
            else {
                let data = {
                    "phoneNumber": mobile
                }
                api.auth.login(data).then((res) => {
                    console.log(res)
                    if (res.message === "Otp Sent ") {
                        setotpSent(true)
                        alert.show('Otp sent', {
                            type: 'success'
                        })
                        setmobileState("mobileOtp")
                    }
                    else {
                        setmobileState("mobile")
                        alert.show('Otp not sent', {
                            type: 'error'
                        })
                    }
                })
            }
        }
        else {
            if (email === "" || email === undefined || !email.includes("@")) {
                alert.info("Please enter a valid email address")
            }
            else {
                let data = {
                    "field": "email",
                    "value": email
                }

                api.auth.verifyField(data).then((res) => {
                    console.log(res)
                    if (res.message === "OTP sent") {
                        setotpSent(true)
                        alert.show('Otp sent', {
                            type: 'success'
                        })
                        setemailState("emailOtp")
                    }
                    else {
                        setemailState("email")
                        alert.show('Otp not sent', {
                            type: 'error'
                        })
                    }
                })
            }
        }


    }

    // Verify otp mobile

    const verifyOtp = () => {
        let otp = first + second + third + fourth
        console.log(first, fourth)

        if (first === "" || first === undefined || second === "" || second === undefined || third === "" || third === undefined || fourth === "" || fourth === undefined) {
            alert.info("Please enter the Otp")
        }
        else {
            let data = {
                "phoneNumber": mobile,
                "otp": otp
            }

            api.auth.verifyOtp(data)
                .then((res) => {
                    console.log(res)
                    if (res.message === "Enter Correct OTP") {
                        // setotpstatus("block")
                        alert.show("Please enter correct Otp", {
                            type: 'error'
                        })
                    } else {
                        // api.seller.updateDescription({ "trm": true }).then((res) => {
                        //     console.log(res)
                        //     alert.show("Verification done", {
                        //         type: 'success'
                        //     })
                        // })
                        alert.success("Phone verfied")
                        setmobileState("verified")
                    }
                })
                .catch(err => console.log(err))
        }

    }


    // Verify email otp

    function verifyMailOtp() {
        let emailotp = firstmail + secondmail + thirdmail + fourthmail
        console.log(firstmail, fourthmail)

        if (firstmail === "" || firstmail === undefined || secondmail === "" || secondmail === undefined || thirdmail === "" || thirdmail === undefined || fourthmail === "" || fourthmail === undefined) {
            alert.info("Please enter the Otp")
        }
        else {
            let data = {
                "email": email,
                "otp": emailotp
            }
            api.auth.verifyOtp(data)
                .then((res) => {
                    console.log(res)
                    if (res.message === "Enter Correct OTP") {
                        // setotpstatus("block")
                        alert.show("Please enter correct Otp", {
                            type: 'error'
                        })
                    } else {
                        // api.seller.updateDescription({ "trm": true }).then((res) => {
                        //     console.log(res)
                        //     alert.show("Verification done", {
                        //         type: 'success'
                        //     })
                        // })
                        alert.success("Email verfied")
                        setemailState("emailverified")
                    }
                })
                .catch(err => console.log(err))
        }

    }

    // Edit mobile number

    function editmobile() {
        setfirst()
        setsecond()
        setthird()
        setfourth();
        setmobileState("mobile")
    }

    // Edit email

    function editmail() {
        console.log("kdenkj")
        setfirstmail()
        setsecondmail()
        setthirdmail()
        setfourthmail()
        setemailState("email")
    }


    // Verify gst 

    function verifyGst() {
        console.log.apply(gstNo)
        setstate("second")
        // axios.post('https://publicservices.gst.gov.in/publicservices/auth/api/search/tp',{"gstin":"18AABCU9603R1ZM"}).then(res=>console.log(res)).catch(err=>console.log(err))
    }

    // Edit gst 

    function editgst() {
        setstate("first")
    }

    function registerSeller() {
        setstate("third")
     
    }

  return (
    <div className='form-register'>  
                       <div className="py-1 back-head-nospc my-3 bg-theme text-white"><span onClick={() => history.goBack()}><i className="fa fa-arrow-left mx-3"></i><img src="/logo-search.png" /> </span>Add Product</div>
                    <div className='container adding-cart'>
                        <div className='text-center fs-19 mt-3 f-500'>
                            Step2
                        </div>

                        <p className='fs-20 mt-5 py-3'> Note : Please add products to complete your registration process.</p>
                        <ul onClick={() => window.location.assign('/form/?=newVendor')} className='d-flex l-n theme-br corner px-5 fs-19'>
                            <li >
                                <img src='/add-to-cart .png' className='w-60 '></img>
                            </li>
                            <li> Add New Product</li>
                        </ul>
                        <ul onClick={() => window.location.assign('/chooseProduct/category/?=newVendor')} className='d-flex l-n theme-br corner px-5 py-1 fs-20 '>
                            <li>
                                <img src='/add-file.png' className='w-60  mt-2 '></img>
                            </li>
                            <li> Choose Product From Toolsvilla Catalogue</li>
                        </ul>


                    </div>
                </div>
  )
}

export default Register3